<template>
  <!-- panel -->
  <el-drawer
    title="设置"
    append-to-body
    direction="rtl"
    :size="400"
    :modal="false"
    :visible.sync="showPanel"
    :before-close="handlePanelClose"
  >
    <div class="setup-panel">
      <el-form label-width="160px">
        <el-form-item label="切换绑定的Tab" v-if="isShowTabs">
          <el-select v-model="filterTabKey" @change="handleChangeType">
            <el-option v-for="item in tabs" :key="item.key" :label="item.label" :value="item.key"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否显示标题">
          <el-switch v-model="isShowTitle" @change="handleChangeType"></el-switch>
        </el-form-item>
        <el-form-item label="是否显示内容">
          <el-switch v-model="isShowContent" @change="handleChangeType"></el-switch>
        </el-form-item>
        <el-form-item label="是否显示其他内容">
          <el-switch v-model="isShowOther" @change="handleChangeType"></el-switch>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "SetupPanel",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isShowTabs: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filterTabKey: this.data.filterTabKey,
      isShowTitle: !!this.data.isShowTitle,
      isShowContent: !!this.data.isShowContent,
      isShowOther: !!this.data.isShowOther,
      showPanel: false
    };
  },
  watch: {
    data(val) {
      if (val) {
        this.filterTabKey = val.filterTabKey;
        this.isShowTitle = !!val.isShowTitle;
        this.isShowContent = !!val.isShowContent;
        this.isShowOther = !!val.isShowOther;
      }
    }
  },
  mounted() {},

  methods: {
    open() {
      this.showPanel = true;
    },
    handlePanelClose() {
      this.showPanel = false;
    },
    handleChangeType() {
      this.$emit("onChange", {
        ...this.data,
        filterTabKey: this.filterTabKey,
        isShowTitle: this.isShowTitle,
        isShowContent: this.isShowContent,
        isShowOther: this.isShowOther
      });
    }
  }
};
</script>

<style lang="less" scoped>
.setup-panel {
  padding: 20px;
}
</style>
